export const selectAuthStatus = (state) => state.auth.status;
export const selectAuthError = (state) => state.auth.error;
